import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ContentWrapper from '../Layout/ContentWrapper';
import { InputField } from '../Common/inputField';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isGGI, isSH, isOCM,
  isDAICHEONG, isLE, isHO, isJRC, isESC, isABBLE, isHMM, isSUN, isSV
} from '../../actions/root_url';

class UserPassword extends Component {
  handleFormSubmit(formProps) {
    const passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    let valid = passwordRegex.test(formProps.new_password);
    if (formProps.new_password !== formProps.renew_password) {
      valid = false;
      alert('New password does not match');
      return;
    }
    if (!valid && !isSV) {
      alert('Password must contain at least 1 lowercase alphabetical character, 1 uppercase alphabetical character, 1 numeric character, 1 special character and the length of password must be greater then 8');
      return;
    } else {
      this.props.editPassword(formProps, this.props.isMainUser);
    }
  }

  showErrorMessage() {
    const editPasswordError = this.props.editPasswordError;
    if (editPasswordError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            { editPasswordError }
          </div>
        </ContentWrapper>
      )
    }
    return;
  }

  renderResponse() {
    const { editUserDetailSuccess, editPasswordError, editPasswordIsLoading } = this.props;
    if (editUserDetailSuccess) {
      return (
        <Row>
          <div className="alert alert-success">
            Success!
          </div>
        </Row>
      );
    } else if (editPasswordIsLoading && !editPasswordError) {
      return (
        <Row>
          <div className="alert alert-info">
            ...<Translate value="reading_data" />
          </div>
        </Row>
      );
    } else if (editPasswordError) {
      return (
        <Row>
          <div className="alert alert-danger">
            {editPasswordError}
          </div>
        </Row>
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;
    
    return (
      <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
        <Row>
          <Col xs={12} className="marginTopStyle">
            <Col xs={5}>
              <label style={{ float: 'right', paddingTop: '2px' }}>
                <Translate value="password" />
              </label>
            </Col>
            <Col xs={5} style={{ float: 'left' }}>
              <Field name="password" component={InputField} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="marginTopStyle">
            <Col xs={5}>
              <label style={{ float: 'right', paddingTop: '2px' }}>
                <Translate value="new_password" />
              </label>
            </Col>
            <Col xs={5} style={{ float: 'left' }}>
              <Field name="new_password" component={InputField} type='password' />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="marginTopStyle">
            <Col xs={5}>
              <label style={{ float: 'right', paddingTop: '2px' }} >
                <Translate value="new_password_again" />
              </label>
            </Col>
            <Col xs={5} style={{ float: 'left' }}>
              <Field name="renew_password" component={InputField} type='password'/>
            </Col>
          </Col>
        </Row>
        <Row style={{ marginTop: '50px', textAlign: 'center' }} >
          <button action="submit" className="btn btn-primary buttonStyle"><em className="fa fa-check" /><Translate value="submit" /></button>
        </Row>
        <br />
        {this.renderResponse()}
      </form>
    );
  }
}

export default UserPassword;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/userPassword.jsx